import { SPECS } from '@/common/constants/specs';

export type ExperimentsLike = { enabled: (spec: string) => boolean };

export const isV2Enabled = (experiments: ExperimentsLike): boolean => {
  return (
    experiments.enabled(SPECS.UseV2) ||
    experiments.enabled(SPECS.UseNewDonationCampaignServiceV2)
  );
};
